import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import ModemCard from "../components/ModemCard";

function ModemNew() {
  const navigate = useNavigate();
  const modem_edit = hasPrivilege('modem_edit');

  useEffect(() => {
    if (!modem_edit) {
      navigate("/");
    }
  }, [navigate, modem_edit])

  if (modem_edit) {
    return <ModemCard newModem={true} editable={true} />;
  }
}

export default ModemNew;
